import { createContext, useContext, useMemo, useState } from "react";

const LanguageContext = createContext({ lang: "it", setLang: () => {}, t: (k) => k });

export const LanguageProvider = ({ children, dictionary }) => {
  const [lang, setLang] = useState("it");
  const value = useMemo(() => {
    const t = (key) => {
      const parts = key.split(".");
      let node = dictionary?.[lang];
      for (const p of parts) {
        if (node == null) return key;
        node = node[p];
      }
      return node ?? key;
    };
    return { lang, setLang, t };
  }, [lang, dictionary]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
